import React from "react";

const AnnouncementEN = () => {
  return (
    <div>
      <div className="announcement">
        <p>
          <b>Our priority is improving our service for you</b>
        </p>

        <div>
          <p><b> October 21, 2024</b></p>
          <p><b>An update from MSH International to PSHCP members</b></p>
          <p>
            <b>
              We are achieving the expectations set out for us by the Government of
              Canada
            </b>
          </p>
          <p>
            In our previous
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html"
              className="link"
              target="_blank"
            >
              update
            </a>
            to you, one pillar of our MSH Customer Service Action Plan was to provide
            you with greater transparency on our service levels and enhancements. We
            continue to work hard on the member experience and are happy to share that
            claims processing times have greatly improved. Focus remains on working
            towards consistently achieving the expectations set out for us by the
            Government of Canada for claims processing service times.
          </p>
          <p>
            We have increased the number of agents at MSH’s Emergency Travel Assistance
            Services and Comprehensive Coverage Contact Centre. This has significantly
            reduced the average wait time and plan members can now reach a contact
            centre agent for emergency and non-emergency calls within two to three
            minutes.
          </p>
          <p>
            To check current wait times for both claims processing and the contact
            centre, please visit our
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-service-dashboard.html"
              className="link"
              target="_blank"
            >
              MSH Service Dashboard
            </a>
            .
          </p>
          <p>
            In our last update, we also mentioned the launch of an enhanced MSH PSHCP
            Member Portal experience that would make it easier and faster to create and
            log in to your account and view your Explanation of Benefits (EOBs), online.
            Since then, we have continued to add more features to serve you. These
            features include:
          </p>
          <ul>
            <li>
              Improved ability to find information such as contact information and the
              types of claims MSH processes
            </li>
            <li>
              Access to important documents on the new Forms and Key Documents page
            </li>
            <li>A frequently asked question section that addresses top questions</li>
            <li>A new claim submission process for Comprehensive Coverage members</li>
          </ul>
          <p>
            We continue to look for opportunities to enhance the MSH PSHCP Member Portal
            to provide the best online experience.
          </p>
          <p>
            Additionally, the
            <a
              href="https://www.welcome.canadalife.com/pshcp/news-and-updates/urgent-escalation-process.html"
              className="link"
              target="_blank"
            >
              Urgent needs escalation process
            </a>
            remains in place. If your claim is for an urgent, life-sustaining
            prescription drug, service or treatment, you are a person with a disability,
            or you are experiencing financial hardship related to your claim, this
            escalation process will ensure your claim is handled as a priority. Only
            claims that have already been submitted to MSH International (MSH) can be
            escalated.
          </p>
          <p>
            If you are experiencing a medical emergency, you can call our contact centre
            within North America (toll-free) at 1-833-774-2700 or (collect) at
            1-365-337-74277 for international calls. Press ‘1’ for your call to be
            immediately routed to an agent. Please do not use this option if your call
            is not urgent or an emergency.
          </p>
          <p>
            If you have additional questions about our Customer Service Action Plan,
            read our
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html#faq"
              className="link"
              target="_blank"
            >
              Frequently Asked Questions (FAQ)
            </a>
            for more information.
          </p>
          <p>
            Thank you for your patience as we continue to improve the member experience.
          </p>
          <p>
            Sincerely,
          </p>
          <p>MSH International</p>
        </div>
        <div>
          <p>
            <br />
            <b>July 24, 2024</b>
            <p>
              <b>The MSH PSHCP Member Portal has been improved</b>
              <p>
                As promised in our Customer Service Action Plan, we are pleased
                to bring you an enhanced
                <a href="https://pshcp-msh.ca/" target="_blank" className="link">
                  MSH PSHCP Member Portal
                </a>
                experience.
              </p>
              <p>
                The portal is now easier to use. Some of the enhancements
                include:
              </p>
              <ul>
                <li>
                  Revamped registration and login pages to make creating and
                  logging in to your account faster.
                </li>
                <li>
                  Restructured landing pages to make important information
                  easier to find, such as contact information and information on
                  what types of claims MSH processes.
                </li>
                <li>
                  An updated digital claim submission process for Comprehensive
                  Coverage members.
                </li>
                <li>
                  New features to view your claims history and explanation of
                  benefits (EOB) online, so you have the latest reimbursement
                  updates when you need them.
                </li>
                <li>
                  A new Forms and Key Documents page to quickly access the
                  documents you need.
                </li>
                <li>
                  A frequently asked questions (FAQ) link that directs you to
                  answers for your most pressing questions.
                </li>
              </ul>
              <br />
              <p>
                We look forward to serving you better.
                <p>Thank you,</p>
                <p>MSH International</p>
              </p>
            </p>
            <br />
            <p><b>May 14, 2024</b></p>
          </p>
          <p>
            In our previous
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html"
              className="link"
              target="_blank"
            >
              update
            </a>
            to you, we listed greater transparency as one of the most important
            pillars of our MSH Customer Service Action Plan. We recognize there
            are areas where we need to improve, and as we address them and make
            progress, we would like to keep you updated on the actions we are
            taking.
          </p>
          <p>
            It is with our commitment to transparency that we are pleased to
            share an updated
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-service-dashboard.html"
              className="link"
              target="_blank"
            >
              MSH Service Dashboard.
            </a>
            In addition to posting the average claims processing time, we are
            now also posting the average expected contact centre wait times for
            both Emergency Travel Assistance and Comprehensive Coverage calls.
            The dashboard will be updated weekly to ensure the most recent
            information on the experience is being provided to you.
          </p>
          <p>
            Another milestone we are pleased to announce is that MSH has
            launched enhancements to the
            <a href="https://pshcp-msh.ca/" target="_blank" className="link">
              MSH PSHCP Member Portal.
            </a>
            The portal now has a fresh online experience. Some of its new
            features include:
            <ul>
              <li>
                an improved online portal registration and log-in page to make
                creating and logging into your account easier and faster
              </li>
              <li>
                online viewing of your claims history and explanation of
                benefits (EOB) statements
              </li>
            </ul>
          </p>

          <p>
            With these enhancements to the portal, we are seeing improvements
            with call wait times as your claims history is now at your
            fingertips.
          </p>

          <p>
            We acknowledge it may take some time for PSHCP members to feel the
            benefits of our improvements. We are prioritizing adding contact
            centre agents and claims processors to our teams every day to better
            our response times and your overall member experience. We are
            monitoring our progress and will adjust our Customer Service Action
            Plan to ensure backlogs and wait times continue to decrease.
          </p>

          <p>
            If you have any questions about our Customer Service Action Plan,
            check out our
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html"
              className="link"
              target="_blank"
            >
              previous update and Frequently Asked Questions (FAQ)
            </a>
            for more information.
          </p>

          <p>
            Thank you for your patience and understanding as we make necessary
            changes to improve your experience.
          </p>
          <p>Sincerely,</p>
          <p>MSH International</p>
        </div>
        <br />
        <b>
          At MSH International (MSH), we are dedicated to ensuring you have
          reliable access to your health benefits when you need them.
        </b>
        <p>
          Since the Public Service Health Care Plan (PSHCP) Emergency Travel
          Assistance Services and Comprehensive Coverage transitioned to MSH,
          the member experience has not met the expected level of service for
          which we strive. We want to assure you that we are committed to
          getting things right.
        </p>
        When the PSHCP transitioned to MSH on July 1, 2023, a significant number
        of claims needed immediate attention. This created a backlog of claims
        to process which was then further increased by the cyber incident from
        earlier this year. Please rest assured, we are working hard to improve
        claims processing times for you.
        <p>
          To help accelerate improvements to your plan member experience, we
          have implemented a Customer Service Action Plan that focuses on 3 core
          priorities:
        </p>
        <ul>
          • reduce contact centre wait times
          <br />
          • improve claims processing times
          <br />
          • establish a process to ensure urgent cases are escalated
          appropriately
          <br />
        </ul>
        <br />
        <b>What you can expect from us</b>
        <br />
        As part of our Customer Service Action Plan, you can count on:
        <p>
          <ul>
            <b>• Shorter contact centre wait times</b>
            <br />
            We are adding more agents to the contact centre every day, and wait
            times are reducing. The average wait for urgent or emergency calls
            is 5 minutes and we are working hard to reduce the average for
            non-emergency calls. With ongoing recruitment, we expect further
            improved response times in the coming weeks.
            <p>
              <b>• Faster claims processing times</b>
              <br />
              While we have already processed more than 17,000 member claims, we
              are rapidly adding more claims processors to both reduce the claim
              backlog and improve the turnaround time for new submissions.
            </p>
            <b>• Escalated urgent and priority cases</b>
            <br />
            Some situations require immediate attention. We have leveraged
            Canada Life’s{" "}
            <u>
              <a
                href="https://www.welcome.canadalife.com/pshcp/news-and-updates/urgent-escalation-process.html"
                target="_blank"
              >
                Urgent needs escalation process
              </a>
            </u>{" "}
            to help ensure urgent claims and issues are quickly identified and
            prioritized by our teams.
            <p>
              If your claim is for an urgent, life-sustaining prescription drug,
              service or treatment, you are a person with a disability, or you
              are experiencing financial hardship related to your claim, this
              escalation process will ensure your claim is handled as a
              priority. Only claims that have already been submitted to MSH
              International (MSH) can be escalated.
            </p>
            If you are experiencing a medical emergency, you can call our
            contact centre within North America (toll-free) at 1-833-774-2700 or
            (collect) at 1-365-337-7427 for international calls. Press ‘1’ for
            your call to be immediately routed to an agent. Please do not use
            this option if your call is not urgent or an emergency.
            <p>
              <b>• Greater transparency</b>
              <br />
              We have added an{" "}
              <u>
                <a
                  href="https://www.welcome.canadalife.com/pshcp/msh/msh-service-dashboard"
                  target="_blank"
                >
                  MSH Service Dashboard
                </a>
              </u>{" "}
              to provide you with the average contact centre and claim
              processing wait times and we have posted a{" "}
              <u>
                <a
                  href="https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html"
                  target="_blank"
                >
                  Frequently Asked Questions (FAQ)
                </a>
              </u>{" "}
              page that provides you with more information. We will keep them
              both updated as wait times continue to improve.
            </p>
            <b>• Enhanced member portal experience</b>
            <br />
            An improved MSH PSHCP Member Portal is coming soon. We are working
            on enhancements that will provide you with a simplified registration
            page and the ability to view your MSH claims history, claims status
            and explanation of benefits (EOB) statements online. If you have not
            created an account yet, we recommend you do so to take advantage of
            the updated digital experience and checking claims status.
          </ul>
        </p>
        <br />
        <b>Committed to you</b>
        <br />
        At MSH, we are committed to ensuring that you have reliable access to
        your health benefits whether you live and work outside of Canada or are
        travelling.
        <p>
          We have more work to do and we will continue to implement our Customer
          Service Action Plan to improve our services for you.
        </p>
        <p>Thank you for your continued patience and understanding.</p>
      </div>
      <p>
        <div className="announcement">
          <div>
            <p>
              <b>An update on the MSH cyber incident</b>
            </p>
            <p>
              <b>May 21, 2024</b>
            </p>
            <p>To PSHCP members,</p>
            <p>
              As part of the commitment we made in February to keep you updated
              on the MSH cyber incident, we are pleased to report that the
              investigation is now complete. You will recall, that upon learning
              of the cyber incident, we immediately took steps with Canada Life
              to contain and investigate the incident. Together, we developed a
              plan to restore service and we enhanced security for our systems
              to protect your personal information.
            </p>

            <p>
              As a result of the investigation, we have found that a very small
              number of plan member personal information was impacted, and we
              have already directly contacted them with next steps.
            </p>

            <p>
              Rest assured that despite the increased potential for cyber
              threats in today’s digital world, protecting your personal
              information is our top priority and we remain vigilant in doing
              everything possible to ensure that your information is secure.
            </p>

            <p>
              To help you protect your personal information even more, consider
              <a
                href="https://www.canadalife.com/internet-security.html"
                className="link"
                target="_blank"
              >
                Canada Life's internet security best practices.
              </a>
            </p>

            <p>
              Thank you and please do not hesitate to
              <a href="https://pshcp-msh.ca/" className="link" target="_blank">
                contact us
              </a>
              if you have any questions about your MSH account.
            </p>

            <p>MSH International </p>
          </div>
          <p>
            <br />
            <b>February 27, 2024</b>
          </p>
          <p>
            We are pleased to report the resumption of all MSH International
            (MSH) services, including the MSH PSHCP Member Portal and claims
            processing systems. You can sign in to your MSH PSHCP Member Portal
            account to securely submit claims online again.
          </p>
          Prior to resuming services, we reinforced our security controls and
          conducted extensive testing to ensure a secure restoration. Although
          the portal is restored, our investigation continues. Rest assured that
          our priority remains to protect your information. If it is determined
          an individual has been affected by this incident, MSH will contact
          them directly.
          <p>
            You may receive reimbursements or communications from MSH about
            claims you previously submitted. Reimbursements and communications
            from official MSH email addresses such as{" "}
            <a href="mailto:sassist@pshcp-msh.ca" target="_blank">
              assist@pshcp-msh.ca
            </a>
            ,{" "}
            <a href="mailto:claim@pshcp-msh.ca" target="_blank">
              claim@pshcp-msh.ca
            </a>{" "}
            and{" "}
            <a href="mailto:auditverification@pshcp-msh.ca" target="_blank">
              auditverification@pshcp-msh.ca
            </a>
            , as well as emails from “Proofpoint Essentials” can be trusted as
            authentic and secure accounts.
          </p>
          Due to higher-than-expected claims volumes, processing times are
          longer than usual. We are working on improving this situation and have
          invested in additional staff to help meet demand.
          <p>
            If your claim is for an urgent, life-sustaining prescription drug,
            service or treatment, you are a person with a disability, or you are
            experiencing financial hardships related to your claim, please
            follow the{" "}
            <u>
              <a
                href="https://www.welcome.canadalife.com/pshcp/news-and-updates/urgent-escalation-process.html"
                target="_blank"
              >
                Urgent needs escalation process.
              </a>
            </u>
          </p>
          <p>
            We are sincerely sorry for the inconvenience of this unexpected
            service disruption and greatly appreciate your patience and
            understanding. Please stay tuned for more information on how we are
            working to improve service times for you.
          </p>
          <p>Thank you,</p>
          <p>MSH International</p>
          <br />
          <hr />
          <br />
          <p>
            <strong>February 12, 2024</strong>
          </p>
          <p>
            MSH International, the PSHCP’s Emergency Travel Assistance Services
            and Comprehensive Coverage provider through Canada Life, recently
            experienced a cyber incident that has impacted service for some of
            its members.
          </p>
          <p>
            Canada Life and MSH are taking this matter very seriously. We are
            working with MSH as they investigate the full impact of the incident
            and develop their plan to restore service and minimize risk to your
            information. The priority is to protect your information and ensure
            that the systems environment is safe before restoring the portal.
          </p>
          <p>
            As a result of this incident, the MSH PSHCP Member Portal is
            unavailable, and MSH is unable to process PSHCP claims or access the
            status of claims.
          </p>
          <p>
            Canada Life's operations are not impacted by this outage at its
            sub-contractor. All non-emergency claims for expenses incurred
            within Canada for all PSHCP members, and non-emergency claims for
            expenses incurred outside of Canada for members with Supplementary
            Coverage can continue to be submitted to Canada Life.
          </p>
          <p>
            If it is determined an individual has been affected by this
            incident, they will be contacted directly.
          </p>
          <p>
            We are sorry for the inconvenience and greatly appreciate your
            patience and understanding as we work hard to resolve this as soon
            as possible.
          </p>
          <p>Thank you,</p>
          <p>MSH International</p>
          <p>
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh-update.html"
              target="_blank"
            >
              MSH update (canadalife.com)
            </a>
          </p>
          <div>
            <a
              href="https://www.welcome.canadalife.com/pshcp/msh/msh-faq.html"
              target="_blank"
            >
              Frequently Asked Questions
            </a>
          </div>
        </div>
      </p>
    </div>
  );
};

export default AnnouncementEN;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/AnnouncementEN.js